// extracted by mini-css-extract-plugin
export default {"table":"YKRSMk","statusCell":"Y7qzWB","numeric":"FsGyHu","links":"dttrOi","empty":"xclM39"};